import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

/**
 * @returns {string}
 */
function getUrl() {
  return 'v3/stock/mt/historytrade-filter/';
}

/**
 * @typedef   {object}    MtHistoryDetailParams
 *
 * @property  {string}   startDate
 * @property  {string}   idxNo
 */

/**
 * @typedef   {object}    MtHistoryDetail
 *
 * @property  {string}    trade_date                    (Ex: "2023-06-23T18:32:34")
 * @property  {string}    order_no                      (Ex: "20077",
 * @property  {string}    stock                         (Ex: "GOTO",
 * @property  {string}    idx_trade_no                  (Ex: "202306230000000324",
 * @property  {string}    idx_order_no                  (Ex: "202306230000000319",
 * @property  {string}    transaction_type              (Ex: "2",
 * @property  {string}    market_type                   (Ex: "0RG",
 * @property  {number}    lot                           (Ex: 20,
 * @property  {number}    shares                        (Ex: 20,
 * @property  {number}    price_matched                 (Ex: 105.0,
 * @property  {number}    fee                           (Ex: null,
 * @property  {number}    total_price                   (Ex: 210000.00,
 * @property  {string}    status_description            (Ex: "Matched",
 * @property  {string[]}  automation_order_item_types   (Ex: [])
 */

/**
 * @typedef   {object}  MtHistoryDetailResponse
 *
 * @property  {object}              data
 * @property  {string}              data.err_code      (Ex: "EC0000000")
 * @property  {string}              data.err_message   (Ex: "APPROVED/OK")
 * @property  {object}              data.paging
 * @property  {object}              data.result
 * @property  {MtHistoryDetail[]}   data.result.results
 *
 * @property  {number}              status            (Ex: 200)
 * @property  {string}              statusText        (Ex: '')
 */

/**
 *
 * @param {string}                url
 * @param {MtHistoryDetailParams} historyDetailParams
 * @returns
 */
function callbackFetch(url, { idxNo, startDate }) {
  return async () => {
    try {
      /**
       * @type {MtHistoryDetailResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          idx_no: idxNo,
          start_date: startDate,
        },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {MtHistoryDetailParams} historyDetailParams
 * @returns
 */
export default function getV3StockMtHistorytradefilterById(historyDetailParams) {
  const url = getUrl();
  const cb = callbackFetch(url, historyDetailParams);
  const key = [url, JSON.stringify(historyDetailParams)];

  return { cb, key };
}
